import { Button } from '../Button'
import { tm } from '../tm'
import i18n from './i18n'
import type { ClientSideLink } from '../Button'
import type { Locales, Project, ProjectId } from '@captaincause/types'
import type { CSSProperties } from 'react'

interface ProjectSimilarProjectsProps {
  baseUrl?: string
  className?: string
  Link?: ClientSideLink
  locale: Locales
  project: Project
  style?: CSSProperties
  seeMore?: (id: ProjectId) => void
}

const emptyObject = {}
export function ProjectSimilarProjects({
  baseUrl = '/projects',
  className = '',
  Link = undefined,
  locale,
  project,
  seeMore = undefined,
  style = emptyObject,
}: ProjectSimilarProjectsProps) {
  if (!project.similar_projects || project.similar_projects.length === 0) {
    return null
  }
  const Component = Link ?? Button

  const t = i18n[locale] ?? i18n.fr

  return (
    <div
      className={tm('px-4 md:col-start-1 md:col-end-3 md:px-0', className)}
      style={style}
    >
      <div className="mb-6 text-lg font-semibold">{t.title}</div>
      <div className="grid w-full grid-cols-2 items-baseline gap-10 px-2 md:grid-cols-4 md:gap-8">
        {project.similar_projects.map((similarProject, index) => (
          <Component
            key={similarProject.id}
            variant="raw"
            href={Link ? `${baseUrl}/${similarProject.slug}` : ''}
            onClick={seeMore ? () => seeMore(similarProject.id) : undefined}
            className={tm(
              'block w-full rounded-md transition-transform duration-300 ease-out hover:scale-[1.01] hover:cursor-pointer focus:scale-[1.01]',
              index > 1 && 'hidden md:block',
            )}
          >
            {similarProject.preview_image ? (
              <div className="relative mb-4 h-[140px] max-h-[140px] w-full rounded-md">
                <img
                  src={similarProject.preview_image}
                  alt=""
                  className="absolute left-0 top-0 h-full w-full rounded-md object-cover"
                  loading="lazy"
                />
              </div>
            ) : null}
            <div className="font-medium">{similarProject.name}</div>
          </Component>
        ))}
      </div>
    </div>
  )
}
